import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {getUsers, getMeetings} from '../api/client';

export const fetchUsers = createAsyncThunk('fetchUsers', async (arg, { getState }) => {
    return await getUsers();
})

export const fetchMeetings = createAsyncThunk('fetchMeetings', async (arg, { getState }) => {
    const state = getState();
    return await getMeetings(state.users.selectedUserId);
})

export const setQueryString = (key, value) => {
    let searchParams = new URLSearchParams(window.location.search)
    searchParams.set(key, value);
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
}

export const usersSlice = createSlice({
    name: 'users',
    initialState: {
        hourOffset: 0,
        fetchUsersStatus: "idle",
        fetchUsersError: null,
        fetchMeetingsStatus: "idle",
        fetchMeetingsError: null,
        saveUserInteractionStatus: "idle",
        saveUserInteractionError: null,
        users: null,
        selectedUserId: "", //react complains if the value of a select is null.
        meetings: null,
        selectedMeetingId: "", //react complains if the value of a select is null.
        selectedMeeting: null
    },
    reducers: {
        setSelectedUserId: (state, action) => {
            state.selectedUserId = action.payload;
            setQueryString("userId", action.payload);
            state.userProfile = null;
            state.fetchMeetingsStatus = "idle";
            state.fetchMeetingsError = null;
            state.meetings = null;
            state.selectedMeetingId = "";
            state.selectedMeeting = null;
        },
        setSelectedMeetingId: (state, action) => {
            state.selectedMeetingId = action.payload;
            setQueryString("meetingId", action.payload);
            state.fetchMeetingsError = null;
            state.selectedMeeting = state.meetings.find(a => a.id === action.payload);
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUsers.pending, (state, action) => {
                state.fetchUsersStatus = 'loading';
                state.users = null;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.fetchUsersStatus = 'succeeded';
                state.users = action.payload;
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.fetchUsersStatus = 'failed';
                state.fetchUsersError = action.error.message;
            })
            .addCase(fetchMeetings.pending, (state, action) => {
                state.fetchMeetingsStatus = 'loading';
                state.meetings = null;
            })
            .addCase(fetchMeetings.fulfilled, (state, action) => {
                state.fetchMeetingsStatus = 'succeeded';
                state.meetings = action.payload;
            })
            .addCase(fetchMeetings.rejected, (state, action) => {
                state.fetchMeetingsStatus = 'failed';
                state.fetchMeetingsError = action.error.message;
            })
    }
})

export const { setSelectedUserId, setSelectedMeetingId } = usersSlice.actions

export default usersSlice.reducer